// extracted by mini-css-extract-plugin
export default {"Routes":"Routes_Routes__bOwFC","Link":"Routes_Link__nMcpW"};